var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36196 5.38117L13.672 10.9542C13.7606 11.0472 13.8101 11.1707 13.8101 11.2992C13.8101 11.4276 13.7606 11.5512 13.672 11.6442L13.666 11.6502C13.623 11.6954 13.5713 11.7314 13.5139 11.756C13.4566 11.7807 13.3949 11.7933 13.3325 11.7933C13.2701 11.7933 13.2083 11.7807 13.151 11.756C13.0937 11.7314 13.0419 11.6954 12.999 11.6502L7.99896 6.40217L3.00096 11.6502C2.95799 11.6954 2.90626 11.7314 2.84893 11.756C2.7916 11.7807 2.72986 11.7933 2.66746 11.7933C2.60507 11.7933 2.54333 11.7807 2.486 11.756C2.42866 11.7314 2.37694 11.6954 2.33396 11.6502L2.32796 11.6442C2.23932 11.5512 2.18987 11.4276 2.18987 11.2992C2.18987 11.1707 2.23932 11.0472 2.32796 10.9542L7.63796 5.38117C7.68466 5.33216 7.74082 5.29314 7.80305 5.26648C7.86528 5.23982 7.93227 5.22607 7.99996 5.22607C8.06766 5.22607 8.13465 5.23982 8.19688 5.26648C8.2591 5.29314 8.31527 5.33216 8.36196 5.38117Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.83774f897dd5c7a8e5d5db07ef1f751b.svg";
export { ForwardRef as ReactComponent };